<template>
    <div class="container">
        <div class="row">
            <div class="col-md-3"><!-- TODO: filters --></div>
            <div class="col-md-8">
                <div class="news-overview-list">
                    <news-list
                        v-for="(article, index) in store.getArticles"
                        :key="article.id"
                        :item="article"
                        :index="index + 1"></news-list>
                </div>
            </div>
        </div>
        <div class="row" v-if="store.articles.length < store.totalResults">
            <div class="col-md-8 offset-md-3">
                <load-more :endpoint="loadMoreEndpoint" :is-knhs="isKnhs"></load-more>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import newsList from './components/news-list.component.vue';
import loadMore from './components/load-more.component.vue';
import { useNewsOverviewStore } from './store/news-overview.store';
import { onBeforeMount, computed } from 'vue';

const store = useNewsOverviewStore();

const props = defineProps<{
    endpoint: string;
    loadMoreEndpoint: string;
    isKnhs?: boolean;
}>();

const endpointUrl = computed(() => {
    return props.isKnhs ? `${props.endpoint}?onlyKnhsEvents=${props.isKnhs}` : props.endpoint;
});
onBeforeMount(() => {
    store.getData(endpointUrl.value);
});
</script>
